module.exports = __webpack_public_path__ + "media/images/zasilky-d54bfd8724c4cf8e836e29ad9ad48318.png";